import { get, post, del, put } from "helpers/api_helper"
import { cachedGet } from "helpers/requestCache"

const SETTINGS_CACHE_TTL_MS = 10 * 60 * 1000
// Same bound as sign-in: the session check gates every page.
const SESSION_TIMEOUT_MS = 15000

// Failures are thrown so the saga can tell a signed-out session (4xx) from an
// API that could not answer (no response, timeout, 5xx).
export const getSession = () => get("/admin/accounts/auth", { timeout: SESSION_TIMEOUT_MS })

export const getSettings = () => cachedGet("/settings", {
  ttlMs: SETTINGS_CACHE_TTL_MS,
  tags: ["settings"],
  fetcher: get,
})


export const login = async (values) => {
  // Bound both requests; preserve transport failures for the visible login error.
  const config = { timeout: 15000 }
  await post("/admin/accounts/auth", values, config)
  return get("/admin/accounts/auth", config)
}

export const logout = async () => {
  let response
  try {
    response = await del("/admin/accounts/auth")
  } catch (error) {
    response = error.response;
  }
  return response
}
